/**
 * This JS class inits all the sliders present on the website.
 * For this matter, we use the following library (imported with npm): http://idangero.us/swiper/#.WZVE03dJZE4
 */

// Correct imports for Swiper 8.x
import Swiper, { Pagination, Navigation, Autoplay } from 'swiper';
Swiper.use([Pagination, Navigation, Autoplay]);
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/autoplay';

export default (function () {
    // Get all instances in the DOM context
    const sliders = document.querySelectorAll('[data-slideshow]');

    /**
     * Initialize all sliders
     */
    function init() {
        // If any exists, instantiate it
        if (sliders.length) {
            for (let i = sliders.length; i--;) {
                const freshSwiper = new Swiper(sliders[i], {
                    // Optional parameters
                    direction: 'horizontal',
                    loop: false,
                    autoplay: {
                        delay: 5000,
                    },
                    pagination: {
                        el: '.swiper-pagination',
                        type: 'bullets',
                        clickable: true,
                    },
                    navigation: {
                        nextEl: sliders[i].querySelector('.swiper-button-next'),
                        prevEl: sliders[i].querySelector('.swiper-button-prev'),
                    },
                });
            }
        }
    }

    if (sliders.length) {
        init();
    }

}());